import { getPath } from '@/router/common'

const baseUrl = {
  title: '参数设置',
  path: 'ParmSetting'
}

export default [
  {
    path: getPath('newIndex', baseUrl),
    name: 'ParmSettingNewIndex',
    component: () => import(/* webpackChunkName: "newIndex" */ '@/views/ParmSetting/newIndex/index.vue'),
    meta: {
      title: '参数设置'
    }
  }
]
